import { Component, EventEmitter, OnInit, Output } from '@angular/core';



@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.css'],
    standalone: false
})
export class SpinnerComponent implements OnInit {

  @Output() animationDone = new EventEmitter<void>();

  onAnimationEnd() {
    this.animationDone.emit();
  }
  constructor() { }

  ngOnInit() {
  }

}
